import Trix from "trix"
import "trix/dist/trix.css";

// color function.  ref: https://github.com/rails/rails/issues/36725
Trix.config.textAttributes.textColour = {
  styleProperty: "color",
  inheritable: true
 }

addEventListener("trix-initialize", function(event) {
  var extraHTML = '<input type="color" class="trix-button colourPicker"/>'

  event.target.toolbarElement.
    querySelector(".trix-button-group--text-tools").
    insertAdjacentHTML("beforeend", extraHTML)

  document.
    querySelectorAll(".colourPicker").forEach(function(cp){
      cp.addEventListener("input", function (event) {
        var trix_element = event.target.closest('trix-toolbar').nextElementSibling
        trix_element.editor.activateAttribute("textColour", event.target.value)
    })
  })
})
// color function

addHeadingAttributes()
addEventListener("trix-initialize", function (event) {
    new RichText(event.target)
})

class RichText {
  constructor(element) {
    this.element = element
    this.insertHeadingElements()
    this.removeUnusedButton()
  }

  insertHeadingElements() {
    this.removeOriginalHeadingButton()
    this.insertNewHeadingButton()
    this.insertHeadingDialog()
  }

  removeUnusedButton() {
    // 加入「連結」的按鈕
    this.buttonGroupTextTools.removeChild(this.toolbarElement.querySelector("[data-trix-attribute=href]"))
  }

  removeOriginalHeadingButton() {
    this.buttonGroupBlockTools.removeChild(this.originalHeadingButton)
  }

  insertNewHeadingButton() {
    this.buttonGroupBlockTools.insertAdjacentHTML("afterbegin", this.headingButtonTemplate)
  }

  insertHeadingDialog() {
    this.dialogsElement.insertAdjacentHTML("beforeend", this.dialogHeadingTemplate)
  }

  get buttonGroupBlockTools() {
    return this.toolbarElement.querySelector("[data-trix-button-group=block-tools]")
  }

  get buttonGroupTextTools() {
    return this.toolbarElement.querySelector("[data-trix-button-group=text-tools]")
  }

  get buttonGroupFileTools() {
    return this.toolbarElement.querySelector("[data-trix-button-group=file-tools]")
  }

  get dialogsElement() {
    return this.toolbarElement.querySelector("[data-trix-dialogs]")
  }

  get originalHeadingButton() {
    return this.toolbarElement.querySelector("[data-trix-attribute=heading1]")
  }

  get toolbarElement() {
    return this.element.toolbarElement
  }

  get headingButtonTemplate() {
    return '<button type="button" class="trix-button trix-button--icon trix-button--icon-heading-1" data-trix-action="x-heading" title="Heading" tabindex="-1">Heading</button>'
  }

  get dialogHeadingTemplate() {
    return `
      <div class="trix-dialog trix-dialog--heading" data-trix-dialog="x-heading" data-trix-dialog-attribute="x-heading">
        <div class="trix-dialog__link-fields">
          <div class="trix-button-group">
            <button type="button" class="trix-button trix-button--dialog" data-trix-attribute="heading1">H1</button>
            <button type="button" class="trix-button trix-button--dialog" data-trix-attribute="heading2">H2</button>
            <button type="button" class="trix-button trix-button--dialog" data-trix-attribute="heading3">H3</button>
            <button type="button" class="trix-button trix-button--dialog" data-trix-attribute="heading4">H4</button>
            <button type="button" class="trix-button trix-button--dialog" data-trix-attribute="heading5">H5</button>
            <button type="button" class="trix-button trix-button--dialog" data-trix-attribute="heading6">H6</button>
          </div>
        </div>
      </div>
     `
  }
}

function addHeadingAttributes() {
  (["h1", "h2", "h3", "h4", "h5", "h6"]).forEach((tagName, i) => {
    Trix.config.blockAttributes[`heading${(i + 1)}`] = { tagName: tagName, terminal: true, breakOnReturn: true, group: false }
  })
}


// Turn off the default Trix captions
Trix.config.attachments.preview.caption = {
  name: false,
  size: false
};

function uploadAttachment(attachment) {
  // Create our form data to submit
  var file = attachment.file;
  var form = new FormData;
  form.append("Content-Type", file.type);
  form.append("faq[image]", file);

  // Create our XHR request
  var xhr = new XMLHttpRequest;
  xhr.open("POST", window.location.origin + "/admin/faqs/upload_editor_image.json", true);
  xhr.setRequestHeader("X-CSRF-Token", Rails.csrfToken());

  // Report file uploads back to Trix
  xhr.upload.onprogress = function(event) {
    var progress = event.loaded / event.total * 100;
    attachment.setUploadProgress(progress);
  }

  // Tell Trix what url and href to use on successful upload
  xhr.onload = function() {
    if (xhr.status === 201) {
      var data = JSON.parse(xhr.responseText);
      return attachment.setAttributes({
        url: data.image_url,
        href: data.image_url
      })
    }
  }
  return xhr.send(form);
}

// Listen for the Trix attachment event to trigger upload
document.addEventListener("trix-attachment-add", function(event) {
  var attachment = event.attachment;
  if ((attachment.file) && window.location.pathname.includes("faqs")) {
    return uploadAttachment(attachment);
  }
});

